("use strict");

let lastIndex = 0;

const state = {
	notifications: []
};

const getters = {
	getNotifications: (state) => state.notifications
};

const actions = {
	addNotification({commit}, {type, message}) {
		commit("addToNotifications", {type, message});
	},
	removeNotification({commit}, notificationIndex) {
		commit("removeFromNotifications", notificationIndex);
	},
	addNotifications({commit}, {collection, message, type}) {
		let time = 200;
		collection.forEach(item => {
			setTimeout(() => {
				commit("addToNotifications", {type, message});
			}, time += time)
		});
	}
};

const mutations = {
	addToNotifications: (state, {type, message}) => {
		let indexOfNotification = 0;
		if (state.notifications.length > 0) {
			indexOfNotification = lastIndex += 1;
		}

		let notification = {indexOfNotification, type, message};
		state.notifications.unshift(notification);
	},
	removeFromNotifications: (state, notificationIndex) => {
		state.notifications = state.notifications.filter(notification => notification.indexOfNotification !== Number(notificationIndex));
	}
};

export default {state, getters, actions, mutations};
